import React , {Component} from 'react';
import * as vars from './Vars';
import Loader from './loader/HomeLoaderV3';
import * as axios from "axios/index";
import {Link} from "react-router-dom";


import Footer from "./div/Footer";
import bellIcon from './../assets/images/icons/bell.svg';


import { Swiper , Autoplay , Pagination } from 'swiper';
Swiper.use([ Autoplay , Pagination]);

class HomeV3 extends Component{

    constructor(props){
        super(props)
        this.state = {
            requestLoading : true ,
            topSlider : [] ,
            branches : [] ,
            lastActiveOrder : null ,
            unreadArticle : false ,
        }

    }


    componentDidMount(){

        localStorage.removeItem("orderDeliveryDateTitle")
        localStorage.removeItem("orderDeliveryDateValue")
        localStorage.removeItem( "orderDeliveryDateIsToday")

        localStorage.removeItem( "use_wallet")
        localStorage.removeItem( "selectedAddressBody")
        localStorage.removeItem( "discount_code")
        localStorage.removeItem( "pay_type")
        localStorage.removeItem( "deliveryPrice")
        localStorage.removeItem( "selectedAddress")
        localStorage.removeItem( "totalPayablePrice")
        localStorage.removeItem( "selectedAddressTitle")
        localStorage.removeItem( "orderDeliveryTimeTime")
        localStorage.removeItem( "orderDeliveryTimeTitle")
        localStorage.removeItem( "orderDeliveryTimeKey")
        localStorage.setItem( "orderDeliveryTimeSelectedByUser" , false)
        localStorage.removeItem("description")
        localStorage.removeItem("orderInPreOrder")

        axios.get(vars.Url +'api/v3/home'  ,{
            params : {
                "api_token" : localStorage.getItem('api_token') ,
            }

        } )
            .then(response => {
                let data = response.data.data
                //console.log(data)
                this.setState({
                    requestLoading : false ,
                    topSlider : data.topSlider ,
                    branches : data.branches ,
                    unreadArticle : data.unreadArticle ,
                })

                let branches = []
                {this.state.branches.map((object , index) =>
                    branches.push({
                        "title":object.title,
                        "phone":object.contactInfo.phone,
                        "address":object.contactInfo.address,
                    })
                )}

                //console.log(data)

                localStorage.setItem("contactBranchesDetails" , JSON.stringify(branches))

                localStorage.setItem("contactInfo_instagramAccount" , data.contactInfo.instagramAccount)
                localStorage.setItem("contactInfo_telegramAccount" , data.contactInfo.telegramAccount)
                localStorage.setItem("contactInfo_aboutUsUrl" , data.contactInfo.aboutUsUrl)

                if (data.user === null)
                {
                    localStorage.removeItem("api_token")
                    localStorage.removeItem("gender")
                    localStorage.removeItem("name")
                    localStorage.removeItem("phone")
                    localStorage.removeItem("unreadMessage")
                    localStorage.removeItem("wallet")
                }
                else
                {
                    localStorage.setItem("api_token" , data.user.api_token)
                    localStorage.setItem("gender" , data.user.gender)
                    localStorage.setItem("name" , data.user.name)
                    localStorage.setItem("phone" , data.user.phone)
                    localStorage.setItem("unreadMessage" , data.user.unreadMessage)
                    localStorage.setItem("wallet" , data.user.wallet)
                }

            })
            .catch(error => {
                // console.log(error)
            })


        const stFcmToken = localStorage.getItem("stFcmToken");

        if (stFcmToken && stFcmToken.length > 0)
        {
            //console.log(0)


            let data = new FormData()
            data.append('api_token' , localStorage.getItem("api_token") )
            data.append('fcm_token' , localStorage.getItem("stFcmToken") )

            axios.post(vars.Url +'api/v1/token/refresh' , data , {
                params : {
                }

            } )
                .then((response) => {
                    //console.log(response)
                })
                .catch( (error) => {
                    //console.log(error)
                })
        }

    }

    componentDidUpdate(prevProps, prevState){
        if (prevState.topSlider !== this.state.topSlider){
            let topSlider = new Swiper('#top-slider', {
                slidesPerView: 1,
                spaceBetween: 15,
                autoplay: {
                    delay: 3000,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            })
        }
    }

    render(){

        return(
            <div id="main-custom-1" className="has-header-1 text-decoration-none">

                <header id="header-1">
                    <div className="container">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">

                                <div className="items-container">

                                    <div className="row h-100 align-items-center justify-content-between">

                                        <div className="col-auto">
                                            <div className="title">
                                                بانان
                                            </div>
                                        </div>

                                        <div className="col-auto">
                                            <div  className={"bell-container " + (this.state.unreadArticle===true ? " active" : "")}>
                                                <Link to="/article">
                                                    <div>
                                                        <img src={bellIcon} alt="bell" className="item-icon" />
                                                    </div>
                                                </Link>
                                            </div>

                                        </div>

                                    </div>

                                </div>



                            </div>
                        </div>
                    </div>
                </header>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6">

                            <div className="items-container">

                                {
                                    this.state.requestLoading === true ?
                                        (
                                            <div>
                                                <Loader />
                                            </div>
                                        ) :
                                        (
                                            <div>

                                                <div className="row">
                                                    <div className="col">

                                                        <div className="swiper-container" id="top-slider" dir="rtl">
                                                            <div className="swiper-wrapper">
                                                                {this.state.topSlider.map((object, index) => {

                                                                    const isHash = object.url === '#'

                                                                    return (
                                                                        <div className="swiper-slide" key={index}>
                                                                            <div className="card-custom-1">

                                                                                {isHash ? (
                                                                                    <div className="img-container">
                                                                                        <img
                                                                                            src={object.imagePreview}
                                                                                            alt={object.title}
                                                                                            className="item-icon"
                                                                                        />
                                                                                    </div>
                                                                                ) : (
                                                                                    <a
                                                                                        href={object.url}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        <img
                                                                                            src={object.imagePreview}
                                                                                            alt={object.title}
                                                                                            className="item-icon"
                                                                                        />
                                                                                    </a>
                                                                                )}

                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}

                                                            </div>
                                                            <div className="swiper-pagination"></div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="row mt-4">
                                                    <div className="col">
                                                        <div className="section-custom-1 pt-5 pb-5 pr-1 pl-1">

                                                            <div className="row mb-2">
                                                                <div className="col">
                                                                    <div className="title-custom-1 pr-3">
                                                                        شعبه‌ها
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div className="row no-gutters">
                                                                {this.state.branches.map((object , index) =>
                                                                    <div className="col-12  p-3" key={index}>
                                                                        <Link to={"/branch/" + object.slug + "/product"} className="card-custom-18">
                                                                            <img src={object.imagePreview} alt={object.title} className="item-icon" />
                                                                            <div className="content">
                                                                                <div className="title">
                                                                                    {object.title}
                                                                                </div>
                                                                            </div>
                                                                        </Link>
                                                                    </div>

                                                                )}
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>




                                            </div>
                                        )
                                }

                            </div>

                        </div>
                    </div>
                </div>

                <Footer page="home"/>
            </div>
        )
    }
}



export default HomeV3